import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Route } from 'react-router-dom';

import App from './app/app';

import './scss/main.scss';

const router = createBrowserRouter([
  {
    path: '/:name',
    element: <App />,
  },
  {
    path: '/',
    element: <App />,
  },
]);

const root = createRoot(document.getElementById('app'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
